import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=be46ba3a&scoped=true&"
import script from "./camera.vue?vue&type=script&lang=js&"
export * from "./camera.vue?vue&type=script&lang=js&"
import style1 from "./camera.vue?vue&type=style&index=1&id=be46ba3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be46ba3a",
  null
  
)

export default component.exports